import React, { useState, useEffect } from 'react';
// import PropTypes from 'prop-types';
// import { useStaticQuery, graphql, Link } from 'gatsby';
import styled from 'styled-components';

import { Logo } from '../../../../../static/icons/logo';
import { Close } from '../../../../../static/icons/close';
import { Menu } from '../../../../../static/icons/menu';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';
import { Row } from '../../../atoms/row/Row';
import { IconLink } from '../../../atoms/iconLink/IconLink';
import { IconBWFooter } from '../../../../../static/icons/iconFooter';
import Dropdown from '../../../molecules/shared/navigationBar/dropdown/Dropdown';
import SearchInput from '../../../molecules/shared/navigationBar/searchInput/SearchInput';
import MobileMenu from './mobileMenu/MobileMenu';

const SpanImage = styled.span`
  svg {
    width: 138px;
    height: 56px;
  }
`;

export const NavigationBar = ({
  data,
  search,
  locale,
  scrolledInit,
  t,
  isTransparent,
  preview,
}) => {
  // location,
  const [scrolled, setScrolled] = useState(scrolledInit ?? false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleScroll = () => {
    const offset = window.scrollY;
    if (!scrolledInit) {
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 896px)');

    const handleMediaQueryChange = () => {
      if (mediaQuery.matches) {
        setIsMobileMenuOpen(false);
      }
    };

    mediaQuery.addEventListener('change', handleMediaQueryChange);

    handleScroll();
    return () => {
      mediaQuery.removeEventListener('change', handleMediaQueryChange);
    };
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav
      id="navbar"
      className={`fixed top-0 w-full z-50 transition-colors duration-300 ${
        scrolled || isMobileMenuOpen
          ? 'bg-white shadow-md bg-opacity-90'
          : isTransparent
          ? 'bg-white shadow-md bg-opacity-90'
          : 'bg-transparent'
      }  ${preview ? 'pointer-events-none' : ''} `}
    >
      <div
        className={`absolute w-3/4 right-0 h-screen mt-24 bg-white bg-opacity-90 transition-transform duration-300 transform ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <MobileMenu
          data={data}
          query={search?.searchValue || ''}
          search={search || null}
          t={t}
        />
      </div>
      <div className="container mx-auto px-8 max-w-7xl">
        <div className="flex items-center justify-between py-5">
          <IconLink title="BusinessWith logo" href="/">
            {scrolledInit ? (
              <SpanImage>
                <IconBWFooter />
              </SpanImage>
            ) : (
              <Logo
                width={138}
                height={56}
                color={
                  !scrolled && !isMobileMenuOpen && !isTransparent
                    ? 'white'
                    : 'black'
                }
              />
            )}
          </IconLink>
          <button
            type="button"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`${
              isMobileMenuOpen ? 'text-black bg-black' : 'text-white bg-black'
            } bg-opacity-30 flex items-center p-2 w-10 h-10 justify-center text-sm rounded-3xl min-[896px]:hidden`}
            aria-controls="navbar-dropdown"
            aria-expanded={isMobileMenuOpen}
          >
            <span className="sr-only">Open main menu</span>
            {isMobileMenuOpen ? (
              <Close color="black" />
            ) : (
              <Menu color="white" />
            )}
          </button>
          <div className="hidden min-[896px]:flex">
            <Row>
              {data.menuItems.map((tab) =>
                tab.id === 'categories' ? (
                  <Dropdown
                    key={tab.title}
                    value={tab.title?.toUpperCase()}
                    menuItems={tab.children.menuItems}
                    footers={tab.children.footers}
                    scrolled={scrolled || isTransparent}
                  />
                ) : (
                  <LinkButton
                    key={tab.id}
                    href={tab.href}
                    variant={`${
                      tab.type === 'button' ? 'primary-filled' : 'transparent'
                    }`}
                    className={`text-sm ${
                      scrolled || isTransparent
                        ? 'text-customGray-900'
                        : 'text-white'
                    }`}
                    label={tab.title?.toUpperCase()}
                  />
                )
              )}
              {search && (
                <SearchInput
                  scrolled={scrolled || isTransparent}
                  handleInputChange={search.onSearchChange}
                  // onBlur={() => setOpenSearch(false)}
                  onBlur={() => {}}
                  results={search.searchSuggestions}
                  open={search.searchVisible}
                  query={search.searchValue}
                  t={t}
                  handleSearchClick={search.onSearchClick}
                  locale={locale}
                />
              )}
            </Row>
          </div>
        </div>
      </div>
    </nav>
  );
};

NavigationBar.propTypes = {};
